import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import CategoryCard from "./CategoryCard";
import axiosInstance from "../../../../../api/axiosInstance";

const CategoryCarousel = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    cssEase: "cubic-bezier(0.87, 0, 0.13, 1)",
    responsive: [
      { breakpoint: 1536, settings: { slidesToShow: 4 } },
      { breakpoint: 1280, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
    appendDots: dots => (
      <div style={{ bottom: "-4Popular Services0px" }}>
        <ul className="m-0 p-0 flex justify-center items-center gap-2"> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div className="dot-custom transition-all duration-300 rounded-full bg-gray-300"></div>
    )
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosInstance.get("/users/categories");
        const data = response.data?.data || [];
        setCategories(data);
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError("Failed to load categories. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading)
    return (
      <div className="text-center py-20">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-[#0097b2] border-t-transparent"></div>
        <p className="mt-4 text-gray-500 font-medium">Loading categories...</p>
      </div>
    );

  if (error)
    return (
      <div className="text-center py-12 text-red-500 bg-red-50 rounded-xl mx-4">
        {error}
      </div>
    );

  return (
    <div className="w-full max-w-9xl mx-auto px-4 md:px-8 py-4 relative">
      {categories.length > 0 ? (
        <Slider {...settings} className="pb-1">
          {categories.map((cat) => (
            <div key={cat._id || cat.id} className="px-3">
              <CategoryCard
                id={cat._id || cat.id}
                title={cat.title || "Untitled Category"}
                description={cat.description }
                imageSrc={
                  cat.imageSrc ||
                  cat.image ||
                  "https://via.placeholder.com/300x200?text=EasyMarg+Category"
                }
              />
            </div>
          ))}
        </Slider>
      ) : (
        <p className="text-center text-gray-500 py-12">
          No categories available.
        </p>
      )}
    </div>
  );
};

export default CategoryCarousel;
